// src/pages/SongBook.jsx
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

const STARQUEST_STORAGE_KEY = "tt_starquest_completed_levels_v1";

// Minimal song list (edit titles anytime)
const SONGS = [
  { level: 1, title: "Twinkle Twinkle Little Star" },
  { level: 2, title: "Happy Birthday" },
  { level: 3, title: "Level 3 Song" },
  { level: 4, title: "Level 4 Song" },
  { level: 5, title: "Level 5 Song" },
  { level: 6, title: "Level 6 Song" },
  { level: 7, title: "Level 7 Song" },
  { level: 8, title: "Level 8 Song" },
  { level: 9, title: "Level 9 Song" },
  { level: 10, title: "LOCKED" },
];

function loadCompletedLevels() {
  try {
    const raw = window.localStorage.getItem(STARQUEST_STORAGE_KEY);
    const arr = JSON.parse(raw || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export default function SongBook() {
  const navigate = useNavigate();
  const [completed] = useState(() => (typeof window !== "undefined" ? loadCompletedLevels() : []));

  const rows = useMemo(() => {
    const done = new Set(completed || []);
    return SONGS.map((s) => ({
      ...s,
      unlocked: s.level === 1 ? true : done.has(s.level),
    }));
  }, [completed]);

  return (
    <div className="min-h-[100dvh] bg-gradient-to-b from-[#9BE7FF] via-[#FDF7FF] to-[#FFE8C7] px-4 py-6">
      <div className="max-w-3xl mx-auto bg-white/90 rounded-[28px] shadow-2xl border border-white/80 p-5 sm:p-7">
        <div className="flex items-center justify-between gap-3">
          <h1 className="text-xl sm:text-2xl font-black text-slate-900">🎵 Song Book</h1>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="px-4 py-2 rounded-full bg-slate-900 text-white text-xs font-extrabold"
          >
            Back
          </button>
        </div>

        <div className="mt-4 space-y-2">
          {rows.map((s) => (
            <div
              key={s.level}
              className={
                "flex items-center justify-between rounded-2xl border px-4 py-3 shadow-sm " +
                (s.unlocked
                  ? "bg-emerald-50 border-emerald-200"
                  : "bg-slate-50 border-slate-200 opacity-80")
              }
            >
              <div className="flex flex-col">
                <div className="text-sm sm:text-base font-black text-slate-900">
                  Level {s.level}: {s.title}
                </div>
                <div className="text-[11px] sm:text-xs text-slate-600">
                  {s.unlocked ? "Unlocked ✅" : "Locked 🔒 (complete the level to unlock)"}
                </div>
              </div>

              <button
                type="button"
                disabled={!s.unlocked}
                onClick={() => navigate(`/level-${s.level}`)}
                className={
                  "px-4 py-2 rounded-full text-xs font-extrabold " +
                  (s.unlocked
                    ? "bg-[#7C3AED] text-white hover:brightness-[1.03]"
                    : "bg-slate-200 text-slate-400 cursor-not-allowed")
                }
              >
                Open
              </button>
            </div>
          ))}
        </div>

        <div className="mt-4 text-xs text-slate-500">
          Unlock rule: a song appears as unlocked if its level is in <span className="font-extrabold">completedLevels</span>.
        </div>
      </div>
    </div>
  );
}